import { render, staticRenderFns } from "./CabinetPage.vue?vue&type=template&id=552e67e0&scoped=true&"
import script from "./CabinetPage.vue?vue&type=script&lang=js&"
export * from "./CabinetPage.vue?vue&type=script&lang=js&"
import style0 from "./CabinetPage.vue?vue&type=style&index=0&id=552e67e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552e67e0",
  null
  
)

export default component.exports